import { render, staticRenderFns } from "./AddProductToCategory.vue?vue&type=template&id=7db74a41&scoped=true&"
import script from "./AddProductToCategory.vue?vue&type=script&lang=js&"
export * from "./AddProductToCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddProductToCategory.vue?vue&type=style&index=0&id=7db74a41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db74a41",
  null
  
)

export default component.exports